import { Button, Input, Typography } from '@breetometer/components';
import { TopupIcon } from 'BreetAssets';
import { cleanRate, formatCurrencyInputAmount, handleApiError, preventFormDefault } from 'BreetHelpers';
import { useFormData } from 'BreetHooks';
import { useGenerateVirtualAccountMutation } from 'BreetRedux';
import { useCallback, useState } from 'react';

import TopupAccountExpired from './components/TopupAccountExpired';
import TopupAccountDetails from './components/TopupAcountDetails';
import { TopupSchema, type TopupSchemaType, type TopupStatusType } from './helpers';

const DialogTopup = () => {
	const topupFormData = useFormData(TopupSchema, { amount: '' }, { mode: 'onChange' });

	const [vbaStatus, setVbaStatus] = useState<'init' | 'account-created' | 'expired'>('init');

	const [generateVirtualAccount, { isLoading: generatingVirtualAccount, data: virtualAccountData }] =
		useGenerateVirtualAccountMutation();

	const requestTopup = useCallback(
		(data: TopupSchemaType) => {
			generateVirtualAccount({
				amount: cleanRate(data.amount).toString(),
				currency: 'ghs',
			})
				.unwrap()
				.then(() => {
					setVbaStatus('account-created');
				})
				.catch(handleApiError);
		},
		[generateVirtualAccount]
	);

	const setTopupStatus = useCallback(
		(status: TopupStatusType) => () => {
			setVbaStatus(status);
		},
		[]
	);

	const amount = formatCurrencyInputAmount(topupFormData.hookFormProps.watch('amount'), 'GHS');

	return (
		<div className='dialog-topup-container bg-primary-500'>
			{vbaStatus === 'init' && (
				<div className='dialog-topup'>
					<TopupIcon className='header-icon' />

					<Typography
						as='h2'
						className='color-tertiary-400'
					>
						Top-Up Account
					</Typography>

					<Typography className='color-neutral-50'>How much would you like to fund your virtual account with?</Typography>

					<form
						className='new-drop-down-input'
						onSubmit={preventFormDefault}
					>
						<Input
							label='Amount'
							id='director-bvn'
							widthType='full'
							placeholder=' '
							maxLength={11}
							{...topupFormData.hookFormProps.register('amount')}
							value={amount}
							errorMessage={topupFormData.hookFormProps.formState.errors.amount?.message}
							required
						/>

						<div className='new-btn-cta'>
							<Button
								onClick={topupFormData.hookFormProps.handleSubmit(requestTopup)}
								className='primary-hover'
								disabled={!topupFormData.isFormCompleted}
								isLoading={generatingVirtualAccount}
								type='button'
							>
								Continue
							</Button>
						</div>
					</form>
				</div>
			)}

			{vbaStatus === 'account-created' && (
				<TopupAccountDetails
					setTopupStatus={setTopupStatus}
					amount={amount}
					data={virtualAccountData?.data}
				/>
			)}

			{vbaStatus === 'expired' && <TopupAccountExpired restartTopup={setTopupStatus('init')} />}
		</div>
	);
};

export default DialogTopup;
